import { render, staticRenderFns } from "./IntegrationSyncChecks.vue?vue&type=template&id=5c452668&scoped=true"
import script from "./IntegrationSyncChecks.vue?vue&type=script&lang=js"
export * from "./IntegrationSyncChecks.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSyncChecks.vue?vue&type=style&index=0&id=5c452668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c452668",
  null
  
)

export default component.exports